import { h, render, Component } from "preact";
import { baseApi } from "./api/baseApi";
import { LOCAL_KEY, LOG_TYPE, WIDGET_TYPE } from "./api/constant";
import {
  debounce,
  formatDiscount,
  getUrl,
  getUrlFile,
  getUrlImage,
  priceFormat,
  setRemoteLog,
  t,
} from "./api/utils";
import "./lib/slider-lib";
import "./lib/slider-lib.less";
import "./assets/styles.less";
import DeviceId from "./lib/deviceId";
import logService from "./logService";
import { getUserDetail } from "./landing/helper";

const logo = getUrl("asset", "logo.png");

/**
 * VALID WIDGET PROPS
 * autosize: true,
 * container_id:'affilio_5623705093613061782'
 * widget_id: '5250112400366338218'
 * widget_type:'ProductWidget
 * redirect_type: 'ProductPage'
 * url: ''
 * is_smart: false
 * main_color: #eee
 * text_color: #000
 * text_button: ""
 * display_title: false
 * default_display_items: 4
 * */
class App extends Component {
  constructor(props) {
    super();
    this.state = {
      products: [],
      banner: "",
      loading: false,
      uniqWidgetId: this.getWidgetId(props),
      productCount: 10,
      init: false,
      device_id: null,
    };
  }

  getWidgetId(props) {
    const widgetId = props.widget_id;
    let id = `wf_${widgetId}`;
    let i = 1;
    const reverseFind = () => {
      if (!document.querySelector(`[widget-aff-id=${id}]`)) {
        return id;
      } else {
        id = `${id}_${i}`;
        i++;
        return reverseFind();
      }
    };
    const uId = reverseFind();
    return uId;
  }

  async asyncLoad(rs, rj) {
    await DeviceId.receiveMessage();
    const widgetType = this.props.widget_type;
    if (widgetType === WIDGET_TYPE.ProductWidget) {
      this.callApi(10, 0);
    } else {
      this.callApi(10, 0);
    }
  }

  componentDidMount() {
    this.asyncLoad();
  }

  componentDidUpdate(preProps) {
    if (this.state.products?.length && !this.state.init) {
      this.setState({ init: true }, () => {
        this.initSlider();
        this.resizeFunction();
        this.autoResizer();
      });
    }
  }

  initSlider() {
    affSlider.init();
    const wId = this.state.uniqWidgetId;
    const sliderElement = document.querySelector(`[widget-aff-id=${wId}]`);
    let i = 0;
    const that = this;
    affSlider.onSlideEnd(sliderElement, function () {
      const s = affSlider.isLatestSlide(sliderElement);
      if (s) {
        if (i < that.state.productCount) {
          i = i + 10;
          that.callApi(20, i);
        }
      }
    });
  }

  getWidgetContainer() {
    const wId = this.state.uniqWidgetId;
    const sliderElement = document.querySelector(`[widget-aff-id=${wId}]`);

    let elm = sliderElement?.parentNode;
    const getParent = () => {
      if (!elm?.classList?.contains("affilio-widget-container")) {
        elm = elm?.parentNode;
        if (elm) {
          return getParent();
        } else {
          return null;
        }
      }
      return elm;
    };

    getParent();
    return elm;
  }

  resizeFunction(preState) {
    window.addEventListener(
      "resize",
      debounce(() => this.autoResizer(), 200)
    );
  }

  autoResizer() {
    try {
      const x = this.getWidgetContainer();
      const width = x?.getBoundingClientRect().width;
      const wId = this.state.uniqWidgetId;
      const sliderElement = document.querySelector(`[widget-aff-id=${wId}]`);
      if (!sliderElement) {
        return;
      }

      if (width < 544) {
        sliderElement.classList.remove("slider-item-show4");
        sliderElement.classList.add("slider-item-show1");
        sliderElement.classList.add("only-show1");
        sliderElement.classList.remove("slider-item-reveal");
      } else if (width < 920 && width >= 544) {
        sliderElement.classList.remove("slider-item-show4");
        sliderElement.classList.add("slider-item-show2");
        sliderElement.classList.remove("only-show1");
        sliderElement.classList.add("slider-item-reveal");
        sliderElement.classList.remove("slider-item-reveal");
      } else if (width >= 920 && width <= 1100) {
        sliderElement.classList.remove("slider-item-show4");
        sliderElement.classList.add("slider-item-show3");
        sliderElement.classList.remove("only-show1");
        sliderElement.classList.add("slider-item-reveal");
      } else {
        sliderElement.classList.add("slider-item-reveal");
        sliderElement.classList.remove("only-show1");
        sliderElement.classList.add("slider-item-show4");
      }
    } catch (e) {
      console.log("error->>>", e);
    }
  }

  callApi(take, skip) {
    const url = this.props.url;
    const widgetId = this.props.widget_id;
    const widgetType = this.props.widget_type;
    const redirectType = this.props.redirect_type;
    const ud = getUserDetail();

    if (widgetId) {
      const dId = DeviceId.getUniqId();
      this.setState({ loading: true });
      baseApi(widgetType, {
        widget_id: widgetId,
        is_public: true,
        redirect_type: redirectType,
        url: url,
        take: take,
        skip: skip,
        device_id: dId,
      })
        .then(async (response) => {
          if (response.success) {
            if (widgetType === WIDGET_TYPE.ProductWidget) {
              this.setState((old) => {
                return {
                  products: [
                    ...old.products,
                    ...(response.data?.products || []),
                  ],
                  productCount: response?.data?.product_count,
                  productWidgetConfig: response?.data?.product_widget_config,
                };
              });
              if (!response?.data?.product_count) {
                setRemoteLog({
                  widgetId: widgetId,
                  host: ud.host,
                  pageUrl: ud.pageUrl,
                  eventType: LOG_TYPE.WIDGET_EMPTY,
                });
              }
            } else {
              const imgUrl = getUrlFile(response.data?.banner_image?.file);
              this.setState({ banner: response.data, imgUrl });
            }
            if (response.data) {
              setRemoteLog({
                widgetId: widgetId,
                host: ud.host,
                pageUrl: ud.pageUrl,
                eventType: LOG_TYPE.WIDGET_VIEW,
              });
            }
          } else {
            setRemoteLog({
              widgetId: widgetId,
              host: ud.host,
              pageUrl: ud.pageUrl,
              eventType: LOG_TYPE.WIDGET_API_ERROR,
              body: response,
            });
            // console.log("API ERROR --->>>", response);
          }
          this.setState({ loading: false });
        }) //print data to console
        .catch((err) => {
          this.setState({ loading: false });

          setRemoteLog({
            widgetId: widgetId,
            host: ud.host,
            pageUrl: ud.pageUrl,
            eventType: LOG_TYPE.WIDGET_SERVER_ERROR,
            body: JSON.stringify(err),
          });
        }); // Catch errors
    }
  }

  openProduct(e, item) {
    // default noFollow
    try {
      const elm = e.srcElement?.parentElement;
      const isButton =
        elm?.classList?.contains("product__button") ||
        elm?.classList?.contains("product__view");

      if (!isButton) {
        window.open(item.widget_url);
      }
    } catch (e) {
      window.open(item.widget_url);
    }
  }

  getStyleBadge() {
    const mainColor = this.props.main_color || "#EE394D";
    return { color: "#fff", backgroundColor: mainColor };
  }

  getStyleButton() {
    const mainColor = this.props.main_color || "#EE394D";
    // const css = "a:hover{ background-color: #00ff00 }";
    return {
      "&>a": {
        color: "#000",
        border: `1px solid ${mainColor}`,
      },
    };
  }

  render() {
    const {
      products,
      banner,
      loading,
      init,
      productCount,
      productWidgetConfig,
    } = this.state;
    const widgetType = this.props.widget_type;
    const customStyle = true;
    const pwc = productWidgetConfig;
    // for backward compatibility
    const isPwcEmpty = pwc === undefined;

    return (
      <div className="affilio_widget_main">
        {widgetType === WIDGET_TYPE.ProductWidget ? (
          productCount ? (
            <div className="main__product">
              {pwc?.show_title && pwc?.widget_title ? (
                <h2 className="main__product__title">
                  {productWidgetConfig?.widget_title}
                </h2>
              ) : (
                ""
              )}
              <div className="products__container">
                {loading ? (
                  <div className={"aff_loading"}>
                    <svg
                      version="1.1"
                      id="L9"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns-xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      enable-background="new 0 0 0 0"
                      xml-space="preserve"
                    >
                      <path
                        fill="#ccc"
                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                      >
                        <animateTransform
                          attributeName="transform"
                          attributeType="XML"
                          type="rotate"
                          dur="1s"
                          from="0 50 50"
                          to="360 50 50"
                          repeatCount="indefinite"
                        />
                      </path>
                    </svg>
                  </div>
                ) : null}

                {init ? (
                  <div
                    widget-aff-id={this.state.uniqWidgetId}
                    className="affilio-slider 
                      slider-item-show4
                      slider-nav-loop
                      slider-nav-autopause 
                      slider-item-reveal
                      slider-item-nogap
                      slider-nav-sm
                      slider-nav-dark
                      slider-nav-autoplay
                      slider-nav-autohide
                      slider-nav-touch 
                      slider-nav-animation-fadein 
                      slider-nav-round
                      slider-nav-animation-fast"
                    data-slider-nav-autoplay-interval="5000"
                  >
                    <ul className="slider-container">
                      {products.map((product, i) => (
                        <li
                          key={product.product_id}
                          className={`slider_item slider__item__${i + 1}${
                            products.length === i + 1 ? " is_last" : ""
                          }`}
                          onClick={(e) => this.openProduct(e, product)}
                        >
                          <div className="product">
                            <div className="product__inner">
                              {product.price?.discount ? (
                                <div
                                  className="product__discount_flag"
                                  style={
                                    customStyle ? this.getStyleBadge() : {}
                                  }
                                >
                                  {formatDiscount(product?.price)}
                                </div>
                              ) : (
                                ""
                              )}
                              <div className="image__wrapper">
                                <div className="image__thump">
                                  <img
                                    src={
                                      product.profile_image_path
                                        ? getUrlImage(product)
                                        : getUrl("asset", "placeholder.png")
                                    }
                                    className="image"
                                    alt={product.name}
                                  />
                                </div>
                              </div>

                              {isPwcEmpty || pwc.show_product_title ? (
                                <div className="product__title">
                                  {product.name}
                                </div>
                              ) : (
                                false
                              )}

                              {isPwcEmpty || pwc.show_price ? (
                                <div>
                                  {product.price?.discount ? (
                                    <div className="product__price product__price__with_discount">
                                      <div className="price__with__discount">
                                        {priceFormat(
                                          product?.price
                                            ?.display_amount_with_discount
                                        )}
                                      </div>
                                      <div className="price__orginal">
                                        {priceFormat(
                                          product?.price?.display_amount
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="product__price">{`${product.price?.display_amount}`}</div>
                                  )}
                                </div>
                              ) : (
                                false
                              )}

                              {isPwcEmpty || pwc.show_product_button ? (
                                <div
                                  className="product__button"
                                  style={
                                    customStyle ? this.getStyleButton() : {}
                                  }
                                >
                                  <a
                                    rel="nofollow"
                                    className="product__view"
                                    style={{
                                      borderColor:
                                        pwc?.style?.color_button || undefined,
                                      backgroundColor:
                                        pwc?.style?.color_button || undefined,
                                      color:
                                        pwc?.style?.color_title_button ||
                                        undefined,
                                    }}
                                    target="_blank"
                                    href={product.widget_url}
                                  >
                                    {product.category?.web_store?.name ? (
                                      <i>
                                        {t("show_product_in")}{" "}
                                        {product.category?.web_store?.name}
                                      </i>
                                    ) : (
                                      t("show_product")
                                    )}
                                  </a>
                                </div>
                              ) : (
                                false
                              )}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>

                    <button type="button" className="slider-nav"></button>
                    <button
                      type="button"
                      className="slider-nav slider-nav-next"
                    ></button>
                  </div>
                ) : null}
              </div>
              <div className="product__logo">
                <img src={logo} />
              </div>
            </div>
          ) : (
            <div />
          )
        ) : (
          ""
        )}

        {widgetType === WIDGET_TYPE.BannerWidget ? (
          <div>
            <div className="banner-container">
              <a
                rel="nofollow"
                href={banner?.widget_url}
                title={banner?.banner?.name}
                target="_blank"
              >
                <img src={this.state?.imgUrl} />
              </a>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

function widget(props) {
  logService.init();

  const widgetDives = document?.querySelectorAll("div[id^=affilio_]");
  widgetDives.forEach((item) => {
    render(<App {...props} />, item);
  });
}

export default widget;
